import type { FC } from "react";

import type SkeletonLengthInterface from "@/components/global/SkeletonComponent/interfaces/SkeletonLengthInterface";
import Skeleton from "@/components/global/SkeletonComponent/server/SkeletonComponent";

const SkeletonKlubCardComponent: FC<SkeletonLengthInterface> = ({
  isDesktop = true,
  length = 4,
}) => {
  const finalLength = !isDesktop ? 2 : length;
  return (
    <div className="flex w-full gap-[16px] overflow-visible pt-6 no-scrollbar md:pt-4 lg:pt-10">
      {Array.from({ length: finalLength }).map((_, index) => (
        <div key={index} className="flex size-full flex-col">
          <Skeleton className="min-h-[232px] !w-[164px] rounded-[16px_60px_6px_6px] md:min-h-[354px] md:!w-[272px] md:rounded-[16px_110px_8px_8px] lg:!w-[270.8px] xl:min-h-[412px] xl:!w-[288px]" />
        </div>
      ))}
    </div>
  );
};

export default SkeletonKlubCardComponent;
